module.exports = __webpack_public_path__ + "img/pincel.94362c53.svg";